import React, { useCallback, useState } from 'react';
import * as Styles from './SideContent.styles';
import {
  IconEllipsis,
  Skeleton,
  Tooltip,
  IconMobile,
  IconDesktop,
  IconMinus,
} from 'gatorcomponents';
import { SettingsPopover } from '../SettingsPopover';

const SideContent = ({
  url,
  isOpen = false,
  locales,
  isSitePreview,
  toggleMinimize,
  getSettingsPopoverProps,
}) => {
  const [showSettings, setShowSettings] = useState(false);
  const [isDesktopView, setIsDesktopView] = useState(true);

  const handleToggleSettings = useCallback(() => {
    setShowSettings(prev => !prev);
  }, []);

  const shouldRenderSkelleton = isSitePreview && !url;

  const renderToolbar = () => (
    <Styles.Toolbar>
      {isSitePreview && (
      <Styles.ToggleViewWrapper>
        <Styles.ToggleView onClick={() => setIsDesktopView(false)} $active={!isDesktopView}>
          <IconMobile size="sm" color={!isDesktopView ? 'primaryMedium' : 'lowDark'} />
        </Styles.ToggleView>
        <Styles.ToggleView onClick={() => setIsDesktopView(true)} $active={isDesktopView}>
          <IconDesktop size="sm" color={isDesktopView ? 'primaryMedium' : 'lowDark'} />
        </Styles.ToggleView>
      </Styles.ToggleViewWrapper>
      )}

      <Styles.ChatActions>
        <Tooltip content={locales.tooltips.minify} preferredPosition="bottomLeft">
          <Styles.ToolbarButton onClick={toggleMinimize}>
            <IconMinus size="sm" color="lowDark" />
          </Styles.ToolbarButton>
        </Tooltip>

        <Tooltip content={locales.tooltips.settings}>
          <Styles.ToolbarButton onClick={handleToggleSettings} $hideInMobile data-testid="toggle-settings">
            <IconEllipsis color="lowDark" />
          </Styles.ToolbarButton>
        </Tooltip>
      </Styles.ChatActions>
    </Styles.Toolbar>
  );

  if (shouldRenderSkelleton) {
    return (
      <Styles.Container data-testid="chat-side-content-skeleton">
        {renderToolbar()}

        <Styles.ContainerSkeletonRow $isDesktopView={isDesktopView}>
          <Styles.HeaderSkeletonRow>
            <Skeleton variant="circle" width="43px" />
            <Skeleton variant="rectangle" width="110px" height="16px" />
            <Skeleton variant="rounded" width="179px" height="32px" />
          </Styles.HeaderSkeletonRow>

          <Styles.HeroSkeletonRow>
            <Skeleton variant="rectangle" width="100%" height="125px" />
          </Styles.HeroSkeletonRow>

          <Styles.CardsWrapperSkeleton>
            {Array.from({ length: 3 }, (_, i) => (
              <Styles.CardSkeleton key={i}>
                <Skeleton variant="rectangle" width="100%" height="125px" />
                <Skeleton variant="paragraph" width="100%" />
              </Styles.CardSkeleton>
            ))}
          </Styles.CardsWrapperSkeleton>

          <Styles.SecondHeaderSkeletonRow>
            <Styles.CardSkeleton $hide={!isDesktopView}>
              <Skeleton variant="rounded" width="75px" height="64px" />
              <Skeleton variant="paragraph" width="197px" />
            </Styles.CardSkeleton>

            <Skeleton variant="rectangle" width="100%" height="125px" />
          </Styles.SecondHeaderSkeletonRow>

          <Styles.RectangleSkeletonWrapper>
            <Skeleton variant="rectangle" width="100%" height="244px" />
          </Styles.RectangleSkeletonWrapper>
        </Styles.ContainerSkeletonRow>
      </Styles.Container>
    );
  }

  if (!isOpen || !url) {
    return null;
  }

  return (
    <Styles.Container data-testid="chat-side-content">
      {renderToolbar()}

      {showSettings && (
        <SettingsPopover
          {...getSettingsPopoverProps()}
          isSideContent
        />
      )}

      <Styles.ContentArea>
        <Styles.Iframe
          data-testid="side-content-iframe"
          src={`${url}`}
          allow="fullscreen"
          $isDesktopView={isDesktopView}
        />
      </Styles.ContentArea>
    </Styles.Container>
  );
};

export default SideContent;
